export default {"src":"/_next/static/media/pocketcasts-dark.aa00c6f1.svg","height":40,"width":142,"blurWidth":0,"blurHeight":0};